import React from "react";
import NavBar from "../sections/NavBar";
import car from "../../images/header/aboutCar.jpeg";
import vasanthi from "../../images/founders/C_vasanthi.webp";
import subha from "../../images/founders/C_subha.webp";
import ravi from "../../images/founders/C_raviPrashanth.webp";
import Footer from "../sections/Footer";
import { Fade } from "react-awesome-reveal";
import driver from "../../images/icons/Cdriver.png";
import route from "../../images/icons/Croute.png";
import way from "../../images/icons/Cway.png";
import vehicle from "../../images/icons/Cvehicle.png";
import c_about from "../../images/header/C_about.webp";
const AboutUs = () => {
  return (
    <>
      <div className="max-w-8xl relative md:px-[120px] px-4" id="about">
        <NavBar />
        <Fade direction="up" triggerOnce ascade damping={0.2}>
          <div className="max-w-5xl mx-auto px-0 py-4 lg:py-12 text-center items-center">
            <h2 className="text-2xl md:text-4xl font-bold mb-0 lg:mb-6 h-[62px]  content-center ">
              About Carzen Logistics
            </h2>
            <p className=" text-[14px] font-medium md:text-[18px] leading-relaxed text-center  text-gray-600">
              We are a trusted travel and transportation company delivering
              safe, comfortable, and efficient mobility solutions, with a core
              focus on reliable daily pick-and-drop services for corporate
              employees
            </p>
          </div>
          {/* Image Section */}
          <div className="rounded-2xl overflow-hidden shadow-md mb-0 lg:mx-1">
            <img
              src={car}
              alt="Fleet of Cars"
              className="w-full h-64 md:h-[436px] object-cover"
            />
          </div>
        </Fade>
        <section className="w-full bg-white text-gray-900">
          {/* 3. What We Do */}
          <div className="py-4 lg:py-16">
            <div className="max-w-8xl mx-auto px-0 text-center">
              <Fade direction="up" triggerOnce damping={0.2}>
                <h2 className="text-2xl md:text-4xl font-bold mb-0 lg:mb-6  h-[62px] content-center ">
                  What We Do
                </h2>
              </Fade>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <Fade direction="up" triggerOnce ascade damping={0.2}>
                  {/* Card 1 */}
                  <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
                    <img
                      src={vehicle}
                      className="w-9 h-9 mb-3 md:mb-4"
                      alt="24/7 Service"
                    />
                    <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
                      Vehicle Excellence
                    </h3>
                    <p className="text-xs sm:text-sm md:text-base text-[#858585]">
                      Well-maintained vehicles for a smooth ride
                    </p>
                  </div>

                  {/* Card 2 */}
                  {/* <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
                    <img
                      src={driver}
                      className="w-9 h-9 mb-3 md:mb-4"
                      alt="Affordable Pricing"
                    />
                    <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
                      Professional Drivers
                    </h3>
                    <p className="text-xs sm:text-sm md:text-base text-[#858585]">
                      Experienced drivers who prioritize safety
                    </p>
                  </div> */}

                  {/* Card 3 */}
                  <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
                    <img
                      src={route}
                      className="w-9 h-9 mb-3 md:mb-4"
                      alt="Safe & Secure"
                    />
                    <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
                      Smart Route Planning
                    </h3>
                    <p className="text-xs sm:text-sm md:text-base text-[#858585]">
                      Carefully planned routes to maximize efficiency
                    </p>
                  </div>
                  <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
                    <img
                      src={driver}
                      className="w-9 h-9 mb-3 md:mb-4"
                      alt="Affordable Pricing"
                    />
                    <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
                      Professional Drivers
                    </h3>
                    <p className="text-xs sm:text-sm md:text-base text-[#858585]">
                      Experienced drivers who prioritize safety
                    </p>
                  </div>

                  {/* Card 4 */}
                  <div className="bg-white rounded-xl shadow-xl hover:shadow-2xl transition-all duration-300 p-5 md:p-6 flex flex-col items-center text-center h-full">
                    <img
                      src={way}
                      className="w-9 h-9 mb-3 md:mb-4"
                      alt="Professional Driver"
                    />
                    <h3 className="text-base md:text-lg lg:text-xl font-medium text-gray-900 mb-2">
                      Flexible Travel Solutions
                    </h3>
                    <p className="text-xs sm:text-sm md:text-base text-[#858585]">
                      Customized travel packages and group trips for families
                      and individuals.
                    </p>
                  </div>
                </Fade>
              </div>
            </div>
          </div>

          {/* 4. Our Values */}
          <div className="max-w-8xl mx-auto px-0 py-4 lg:py-16 text-center">
            <Fade direction="up" triggerOnce ascade damping={0.2}>
              <h2 className="text-2xl md:text-4xl font-bold mb-0 lg:mb-6 h-[62px] content-center  ">
                What We Stands For
              </h2>
              <div className="about-section  flex  flex-col md:flex-row  gap-4 lg:gap-8">
                {/* SHARED HEIGHT WRAPPER */}
                <div className=" about-image w-full  md:w-1/2 flex">
                  <img
                    src={c_about}
                    alt="About carzen"
                    className="w-full object-cover rounded-2xl"
                  />
                </div>
                <div className="about-text w-full md:w-1/2">
                  <div className=" text-gray-700 ">
                    <p className="text-[14px] md:text-[18px] font-medium  content-center leading-relaxed text-justify">
                      We are deeply committed to delivering transportation
                      services that consistently uphold the highest standards of
                      safety, punctuality, and comfort. Every journey we
                      undertake is carefully planned and executed to ensure a
                      reliable and stress-free commuting experience for
                      employees, enabling organizations to operate smoothly and
                      on schedule. At the same time, we strive to create
                      comfortable and enjoyable travel experiences for families
                      and individuals, combining dependable service with
                      thoughtful attention to detail. Through our customer-first
                      approach, we aim to build long-term trust and deliver
                      value in every mile we drive. We continuously evaluate and
                      improve our services to adapt to evolving needs and exceed
                      customer expectations.
                    </p>
                  </div>
                </div>
              </div>
            </Fade>
          </div>

          {/* 5. Leadership */}
          <div className=" text-gray-900 py-4 lg:py-16 text-center">
            <Fade direction="up" triggerOnce ascade damping={0.2}>
              <div className="max-w-7xl mx-auto px-0">
                <h2 className="text-2xl md:text-4xl font-bold mb-0 lg:mb-6 text-center h-[62px] content-center ">
                  Meet the Team
                </h2>
                <p className="text-[14px] font-medium md:text-[18px] text-slate-600 mb-6">
                  A passionate team dedicated to precision, reliability, and
                  exceptional logistics service
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-8">
                  <div className=" md:p-0 text-center  ">
                    {/* IMAGE WRAPPER */}
                    <div className="group relative w-full max-w-[416px] aspect-[416/530] mx-auto mb-6 rounded-2xl overflow-hidden">
                      {/* IMAGE */}
                      <img
                        src={vasanthi}
                        alt="Vasanthi Nagarajan"
                        className="w-full h-full object-cover group-hover:bg-black/50"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-700 ease-in-out"></div>

                      {/* OVERLAY */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-700 ease-in-out">
                        {/* CONTENT */}
                        <div
                          className="
    absolute inset-x-0 bottom-6
    p-4 text-left
    transition-all duration-700 ease-in-out
    translate-y-[70%]
    group-hover:translate-y-0
  "
                        >
                          {/* TITLE + NAME */}
                          <h3 className="text-lg font-semibold text-white leading-tight">
                            Vasanthi Nagarajan
                          </h3>
                          <p className="text-xs uppercase tracking-wide text-gray-300">
                            Founder
                          </p>

                          {/* DESCRIPTION */}
                          <p
                            className="
            mt-3 text-sm text-gray-200 leading-relaxed
            opacity-0 translate-y-3
            group-hover:opacity-100  group-hover:text-justify group-hover:translate-y-0
            transition-all duration-700 ease-in-out
            max-w-[90%]
          "
                          >
                            Vasanthi Nagarajan brings over 10 years of logistics
                            management experience, delivering strategic
                            leadership that drives growth, reliability, and
                            service excellence
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=" md:p-0 text-center ">
                    {/* IMAGE WRAPPER */}
                    <div className="group relative w-full max-w-[420px] aspect-[416/530] mx-auto mb-6 rounded-2xl overflow-hidden">
                      {/* IMAGE */}
                      <img
                        src={subha}
                        alt="Subha N"
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-700 ease-in-out"></div>

                      {/* OVERLAY */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-700 ease-in-out">
                        {/* CONTENT */}
                        <div
                          className="
         absolute inset-x-0 bottom-6
    p-4 text-left
    transition-all duration-700 ease-in-out
    translate-y-[70%]
    group-hover:translate-y-0
        "
                        >
                          {/* TITLE + NAME */}
                          <h3 className="text-lg font-semibold text-white leading-tight">
                            Subha N
                          </h3>
                          <p className="text-xs uppercase tracking-wide text-gray-300">
                            Co-Founder
                          </p>

                          {/* DESCRIPTION */}
                          <p
                            className="
            mt-3 text-sm text-gray-200 leading-relaxed
            opacity-0 translate-y-3
            group-hover:opacity-100 group-hover:text-justify  group-hover:translate-y-0
            transition-all duration-700 ease-in-out
            max-w-[90%]
          "
                          >
                            Subha N leads operations and client relations with a
                            strong focus on professionalism, safety, and
                            consistent quality across every mile we serve.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className=" md:p-0 text-center ">
                    {/* IMAGE WRAPPER */}
                    <div className="group relative w-full max-w-[420px] aspect-[416/530] mx-auto mb-6 rounded-2xl overflow-hidden">
                      {/* IMAGE */}
                      <img
                        src={ravi}
                        alt="Ravi Prashanth"
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-all duration-700 ease-in-out"></div>

                      {/* OVERLAY */}
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-700 ease-in-out">
                        {/* CONTENT */}
                        <div
                          className="
        absolute inset-x-0 bottom-6
    p-4 text-left
    transition-all duration-700 ease-in-out
    translate-y-[70%]
    group-hover:translate-y-0
        "
                        >
                          {/* TITLE + NAME */}
                          <h3 className="text-lg font-semibold text-white leading-tight">
                            Ravi Prashanth
                          </h3>
                          <p className="text-xs uppercase tracking-wide text-gray-300">
                            Founder
                          </p>

                          {/* DESCRIPTION */}
                          <p
                            className="
            mt-3 text-sm text-gray-200 leading-relaxed
            opacity-0 translate-y-3
            group-hover:opacity-100 group-hover:text-justify  group-hover:translate-y-0
            transition-all duration-700 ease-in-out
            max-w-[90%]
          "
                          >
                            Ravi Prashanth leads the mission to simplify
                            logistics and travel for IT-driven businesses,
                            delivering scalable, tech-enabled mobility solutions
                            with precision.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default AboutUs;
